import React, {useState, useRef, useEffect} from 'react';
import '../ContactPage/Styles.css'
import useTitle from '../../useTitle';
import ContactSection from '../../components/ContactSectionPage/Index';

const Contact = () => {
  useTitle("Contact");
  // eslint-disable-next-line no-unused-vars
  const [isOpen, setIsOpen] = useState(false);
  // Close the navbar when a link is clicked

  const formRef = useRef(null);
  const selectRef = useRef(null);
  const captchaRef = useRef(null);

  useEffect(() => {
    const formElement = formRef.current;
    const selectElement = selectRef.current;

    if (formElement) formElement.reset();
    if (selectElement) selectElement.selectedIndex = 0;

    const handleSubmit = (e) => {
      const hCaptcha = formElement.querySelector('textarea[name="h-captcha-response"]')?.value;
      if (!hCaptcha) {
        e.preventDefault();
        alert("Gelieve de captcha in te vullen.");
      }
    };

    formElement.addEventListener('submit', handleSubmit);

    const loadCaptchaScript = () => {
      const script = document.createElement('script');
      script.src = 'https://web3forms.com/client/script.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (captchaRef.current && window.hcaptcha) {
          window.hcaptcha.render(captchaRef.current);
        }
      };
    };

    loadCaptchaScript();

    const handlePageShow = (event) => {
      const isBack = event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward";

      if (isBack) {
        if (formRef.current) formRef.current.reset();
        if (selectRef.current) selectRef.current.selectedIndex = 0;
        window.location.reload();

        // Verwijder handmatig verlopen hCaptcha token
        const oldToken = formRef.current?.querySelector('textarea[name="h-captcha-response"]');
        if (oldToken) oldToken.remove();

        // Reset hCaptcha widget
        if (window.hcaptcha && captchaRef.current) {
          window.hcaptcha.reset();
        }
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      formElement.removeEventListener('submit', handleSubmit);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);
  return (
    <>
        <div className='contactPageSectionContainer'>
          <div className='contactTitleContainer'>
            <h1 className='contactTitle'>Contact Form</h1>
          </div>
          <div className='contactTitleDescription'>
            <p>Do you have questions about a jewel or a custom design? I’d be happy to help. Fill in the form below and I will get back to you as soon as possible.</p>
          </div>

          <div className='formulierContact'>
            <form ref={formRef} action="https://api.web3forms.com/submit" method="POST">
              <input type="hidden" name="access_key" value="49e84981-7156-42e4-aaa7-5dae8bb46ffe" />
              <input type="hidden" name="subject" value="New Submission for ricovanhoutteghem.be" />
              <input type="hidden" name="from_name" value="Rico Vanhoutteghem" />
              <input type="hidden" name="redirect" value="https://ricovanhoutteghem.be/thankyou" />
              <input type="checkbox" name="botcheck" className="hidden" style={{ display: 'none' }} />

              <label htmlFor="fname">Name and Lastname<span className="required"> *</span></label>
              <input type="text" id="fname" name="name_and_lastname" placeholder='Type your first and last name here…' required />

              <label htmlFor="emailadres">E-mail<span className="required"> *</span></label>
              <input type="email" id="emailadres" name="email" placeholder='Type your e-mail here…' required />

              <label htmlFor="phonenumber">Phone number<span className="required"> *</span></label>
              <input type="text" id="Telefoonnummer" name="phone_number" placeholder='Type your phone number here…' required />

              <label htmlFor="subjectofform">Subject<span className="required"> *</span></label>
              <select className="form-control onderwerp-menu" name="form_subject" ref={selectRef} required>
                <option disabled hidden>Select a subject...</option>
                <option>Rings</option>
                <option>Earrings</option>
                <option>Bracelets</option>
                <option>Pendants</option>
                <option>Tie Clips & Cufflinks</option>
                <option>Brooches & Hairpins</option>
                <option>Custom Jewelry</option>
                <option>Book an appointment</option>
                <option>Other</option>
              </select>

              <label htmlFor="exampleFormControlTextarea1">Message<span className="required">*</span></label>
              <textarea className="form-control reden" id="exampleFormControlTextarea1" rows="3" name="message" placeholder='Type your message here…' required></textarea>

              <label className='privacybeleidContainer' htmlFor="privacyConsent">
                I consent to the use of my personal data as described in the
                <a href="/files/privacyverklaring/Rico-Vanhoutteghem-Privacyverklaring.pdf" target="_blank" className='privacyBeleid'>privacy policy</a>
                <input type="checkbox" id="privacyConsent" name="privacy_consent" required />
              </label>

              <div
                className="h-captcha"
                data-captcha="true"
                data-lang="en"
                data-theme="light"
                data-size="normal"
                aria-required="true"
                data-sitekey="50b2fe65-b00b-4b9e-ad62-3ba471098be2"
                ref={captchaRef}
              ></div>

              <input type="submit" value="SUBMIT" />
            </form>
          </div>
        </div>

        <ContactSection />
    </>
  )
}

export default Contact;
